import { combineReducers }        from 'redux';
import { reducer as formReducer } from 'redux-form';

import detailPage       from './detailPage';
import eventList        from './eventsList';
import header           from './header';
import payment          from './payment';
import presenterList    from './presenterList';
import venueList        from './venueList';
import resourcePackList from './resourcePackList';
import moduleList       from './moduleList';
import timetableList    from './timetableList';
import courseList       from './courseList';
import adminEventList   from './adminEventList';
import publicCourseList from './publicCourseList';
import bookingList      from './bookingList';
import promotionList    from './promotionList';
import marketingPage    from './marketingPage';
import selectCourseList from './selectCourseList';
import statsList        from './statsList';
import marketingAd      from "./marketingAd";

export default combineReducers({
    form: formReducer,
    detailPage,
    eventList,
    header,
    payment,
    presenterList,
    venueList,
    resourcePackList,
    moduleList,
    timetableList,
    courseList,
    adminEventList,
    publicCourseList,
    bookingList,
    promotionList,
    marketingPage,
    selectCourseList,
    statsList,
    marketingAd
});


// WEBPACK FOOTER //
// ./reducers/index.js